import { render, staticRenderFns } from "./new-credit-ticket.vue?vue&type=template&id=71418aa8&scoped=true&"
import script from "./new-credit-ticket.vue?vue&type=script&lang=js&"
export * from "./new-credit-ticket.vue?vue&type=script&lang=js&"
import style0 from "./new-credit-ticket.vue?vue&type=style&index=0&id=71418aa8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71418aa8",
  null
  
)

export default component.exports